import _set from 'lodash/set';
import _get from 'lodash/get';


export type Validation = {
  [key: string]: Validation | null | undefined;
  // @ts-expect-error - TS2411 - Property 'errors' of type 'string[] | undefined' is not assignable to 'string' index type 'Validation | null | undefined'.
  errors?: string[];
};

export function setError<V extends Validation = Validation>(
  error: V | null | undefined,
  test: unknown,
  path: string,
  words: string,
): V | null | undefined {
  if (!test) {
    // @ts-expect-error - TS2322 - Type 'V | {}' is not assignable to type 'V | null | undefined'.
    error = error || {};
    const fullPath = path ? `${path}.errors` : 'errors';
    const errors = _get(error, fullPath) || [];
    // @ts-expect-error - TS2723 - Cannot invoke an object which is possibly 'null' or 'undefined'. | TS2349 - This expression is not callable.
    errors.push(words);
    // @ts-expect-error - TS2769 - No overload matches this call.
    _set(error, fullPath, errors);
  }
  return error;
}

export function getErrors(
  error: Validation | null | undefined,
  path: string,
): string[] | null | undefined {
  // @ts-expect-error - TS2322 - Type 'Validation | null | undefined' is not assignable to type 'string[] | null | undefined'.
  return _get(error, `${path}.errors`);
}

export function hasError(
  error: Validation | null | undefined,
  path: string,
  words: string,
): boolean {
  return (getErrors(error, path) || []).includes(words);
}

export function filterValidation(
  errorArg: Validation | null | undefined,
  keys: Array<string>,
): Validation | null | undefined {
  let result;
  for (const key of keys) {
    const subValidation = errorArg?.[key];
    if (subValidation) {
      result = {
        // @ts-expect-error - TS2698 - Spread types may only be created from object types.
        ...result,
        ...subValidation,
      };
    }
  }
  return result;
}
